module.exports = __webpack_public_path__ + "img/icon285.c2e2a8f5.png";